export const PERMISSION = {
  ADMIN: 'Admin',
  LOAN_OFFICER: 'LoanOfficer',
  LOAN_PROCESSOR: 'LoanProcessor',
  OWNER: 'Owner',
  SUPER_ADMIN: 'SuperAdmin',
};
